 
    <style scoped>
        
        .page-content {
            flex: 1;
            
            overflow-y: auto;
            padding-bottom: 70px;
        }
        
        /* 头部信息 */
        .header-info {
            background: white;
            border-radius: 16px;
            padding: 20px;
            margin-bottom: 20px;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
        }
        .info-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
        }
        .info-label {
            color: #666;
            font-size: 15px;
        }
        .info-value {
            font-size: 15px;
            font-weight: 500;
            color: #333;
        }
        
        /* 储存编号选择 */
        .storage-selection {
            background: white;
            border-radius: 16px;
            padding: 20px;
            margin-bottom: 20px;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
        }
        .selection-title {
            font-size: 16px;
            font-weight: 600;
            color: #3498db;
            margin-bottom: 15px;
        }
        .storage-options {
            display: flex;
            flex-direction: column;
            gap: 12px;
        }
        .storage-option {
            display: flex;
            align-items: center;
            padding: 12px 15px;
            border: 1px solid #ddd;
            border-radius: 10px;
            cursor: pointer;
            transition: all 0.3s;
        }
        .storage-option.selected {
            border-color: #3498db;
            background: #e8f4fc;
        }
        .storage-option input[type="radio"] {
            margin-right: 10px;
        }
        .storage-code {
            font-weight: 500;
        }
        
        /* 续存信息 */
        .renew-info {
            background: white;
            border-radius: 16px;
            padding: 20px;
            margin-bottom: 20px;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
        }
        .info-item {
            margin-bottom: 20px;
        }
        .info-item:last-child {
            margin-bottom: 0;
        }
        .info-title {
            font-size: 16px;
            font-weight: 600;
            color: #3498db;
            margin-bottom: 15px;
        }
        .price-display {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px;
            background: #f8f9fa;
            border-radius: 10px;
            font-size: 16px;
        }
        .price-label {
            color: #666;
        }
        .price-value {
            font-weight: 600;
            color: #e74c3c;
        }
        
        /* 年限选择 */
        .year-selection {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 15px;
            background: #f8f9fa;
            border-radius: 10px;
        }
        .year-label {
            font-size: 16px;
            color: #666;
        }
        .year-control {
            display: flex;
            align-items: center;
        }
        .control-btn {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            border: 1px solid #3498db;
            background: white;
            color: #3498db;
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.3s;
        }
        .control-btn:disabled {
            border-color: #ccc;
            color: #ccc;
            cursor: not-allowed;
        }
        .control-btn:not(:disabled):hover {
            background: #3498db;
            color: white;
        }
        .year-value {
            width: 50px;
            text-align: center;
            font-size: 18px;
            font-weight: 600;
            margin: 0 10px;
        }
        
        /* 总金额 */
        .total-amount {
            background: white;
            border-radius: 16px;
            padding: 20px;
            margin-bottom: 20px;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
            text-align: center;
        }
        .total-label {
            font-size: 16px;
            color: #666;
            margin-bottom: 10px;
        }
        .total-value {
            font-size: 28px;
            font-weight: 700;
            color: #e74c3c;
            margin-bottom: 20px;
        }
        .confirm-btn {
            background: linear-gradient(135deg, #3498db 0%, #2ecc71 100%);
            color: white;
            border: none;
            border-radius: 10px;
            padding: 15px;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            width: 100%;
            transition: all 0.3s;
        }
        .confirm-btn:hover {
            opacity: 0.9;
            transform: translateY(-2px);
        }
        
        /* 底部导航栏 */
        .tab-bar {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            height: 60px;
            background: white;
            display: flex;
            justify-content: space-around;
            align-items: center;
            border-top: 1px solid #eee;
            box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
            z-index: 100;
            max-width: 420px;
            margin: 0 auto;
        }
        .tab-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            flex: 1;
            height: 100%;
            cursor: pointer;
            transition: all 0.3s;
            color: #999;
        }
        .tab-item.active {
            color: #3498db;
        }
        .tab-icon {
            font-size: 20px;
            margin-bottom: 4px;
        }
        .tab-name {
            font-size: 12px;
        }
    </style>
 
    <template >
       
            <div class="page-content">
                <!-- 头部信息 -->
                <div class="header-info">
                    <div class="info-row">
                        <div class="info-label">姓名：</div>
                        <div class="info-value">张三</div>
                    </div>
                    <div class="info-row">
                        <div class="info-label">储户编号：</div>
                        <div class="info-value">HC202512345</div>
                    </div>
                </div>
                
                <!-- 储存编号选择 -->
                <div class="storage-selection">
                    <div class="selection-title">选择储存编号：</div>
                    <div class="storage-options">
                        <label class="storage-option" :class="{selected: selectedStorage === 'HC202512345-1'}">
                            <input type="radio" value="HC202512345-1" v-model="selectedStorage">
                            <span class="storage-code">HC202512345-1</span>
                        </label>
                        <label class="storage-option" :class="{selected: selectedStorage === 'HC202512345-2'}">
                            <input type="radio" value="HC202512345-2" v-model="selectedStorage">
                            <span class="storage-code">HC202512345-2</span>
                        </label>
                    </div>
                </div>
                
                <!-- 续存信息 -->
                <div class="renew-info">
                    <div class="info-item">
                        <div class="info-title">储存费用</div>
                        <div class="price-display">
                            <span class="price-label">储存费</span>
                            <span class="price-value">600元/年</span>
                        </div>
                    </div>
                    
                    <div class="info-item">
                        <div class="info-title">续存年限</div>
                        <div class="year-selection">
                            <span class="year-label">续存年限</span>
                            <div class="year-control">
                                <button class="control-btn" :disabled="years <= 1" @click="decreaseYears">-</button>
                                <span class="year-value">{{ years }}</span>
                                <button class="control-btn" :disabled="years >= 10" @click="increaseYears">+</button>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- 总金额 -->
                <div class="total-amount">
                    <div class="total-label">总金额</div>
                    <div class="total-value">￥{{ totalAmount }}</div>
                    <button class="confirm-btn" @click="confirmRenewal">确认</button>
                </div>
            </div>
            
             
        
    </template>

    <script>
        export default{
            name:'Xucun',
            data(){return {
                currentTab: 'mine',
                selectedStorage: 'HC202512345-1',
                years: 1,
                pricePerYear: 600
            }},
            computed: {
                totalAmount() {
                    return (this.years * this.pricePerYear).toFixed(2);
                }
            },
            methods: {
                
                decreaseYears() {
                    if (this.years > 1) {
                        this.years--;
                    }
                },
                increaseYears() {
                    if (this.years < 10) {
                        this.years++;
                    }
                },
                confirmRenewal() {
                    alert(`确认续存${this.years}年，总金额${this.totalAmount}元`);
                    // 实际应用中：跳转到支付页面
                }
            }
        };
    </script>
